import React from 'react';
import { Button, HSpacer, Text, VSpacer, Dialog } from '@/components/DesignSystem';
import { Divider, Stack } from "@mui/material";
import beta from '@/assets/icons/beta.svg';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AboutInsightsModalProps {
  open: boolean,
  onClose: () => void
}

export const AboutInsightsModal: React.FC<AboutInsightsModalProps> = ({
  open,
  onClose,
}) => {

  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dialog
      onClose={onClose}
      open={open}
      showCloseButton={false}
      testID="about-ai-insights-dialog"
      title={
        <Stack alignItems="center" direction="row">
          <Text category='h4'>{t($ => $.aiInsights.aboutModal.title)}</Text>
          <HSpacer size="4" />
          <img
            alt="Beta"
            height="16"
            src={beta}
          />
        </Stack>
      }
    >
      <VSpacer size="2" />
      <Text category='p2' sx={{ fontSize: '18px', lineHeight: '22px' }}>
        {t($ => $.aiInsights.aboutModal.disclaimers)}
      </Text>
      <VSpacer size="5" />
      <Text category="body-medium" sx={{ color: theme.palette.text.primary, fontWeight: 500 }}>
        {t($ => $.aiInsights.aboutModal.dataExclusions.title)}
      </Text>
      <VSpacer size="2" />
      <Text category="body-medium" sx={{ color: theme.palette.text.secondary }}>
        {t($ => $.aiInsights.aboutModal.dataExclusions.description)}
      </Text>
      <VSpacer size="5" />
      <Divider />
      <VSpacer size="5" />
      <Text category="body-medium" sx={{ color: theme.palette.text.primary, fontWeight: 500 }}>
        {t($ => $.aiInsights.aboutModal.predictionAccuracy.title)}
      </Text>
      <VSpacer size="2" />
      <Text category="body-medium" sx={{ color: theme.palette.text.secondary }}>
        {t($ => $.aiInsights.aboutModal.predictionAccuracy.betaWarning)}
      </Text>
      <VSpacer size="4" />
      <Text category="body-medium" sx={{ color: theme.palette.text.secondary }}>
        {t($ => $.aiInsights.aboutModal.predictionAccuracy.dataQualityWarning)}
      </Text>
      <VSpacer size="5" />
      <VSpacer size="3" />
      <Stack direction="row" justifyContent="flex-end">
        <Button
          onClick={onClose}
          sx={{ 
            backgroundColor: theme.palette.background.paper, 
            color: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: theme.palette.background.paper,
            },
          }}
          testID="about-ai-insights-close-button"
        >
          {t($ => $.common.actions.close)}
        </Button>
      </Stack>
    </Dialog>
  );
};
